import { Component ,ElementRef} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
declare var $:any;
declare var CKEDITOR: any;


@Component({
  selector: 'app-faq-add-edit',
  templateUrl: './faq-add-edit.component.html',
  styleUrls: ['./faq-add-edit.component.scss']
})
export class FaqAddEditComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public CurrentDetail:any=[];
  public currentUrl:any=this.router.url;
  public LoginCheck:boolean=false;
  public selectedFile: any = "";
  public selectedDocFile: any = "";

  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  docURL: any = "";
  public message: any;

  staticData = new FormGroup({
    title:new FormControl('',Validators.compose([
      Validators.required])),
    description:new FormControl('',Validators.compose([
      Validators.required])),
  })
  
  FaqData = new FormGroup({
    question:new FormControl('',Validators.compose([
      Validators.required])),
    answer:new FormControl('',Validators.compose([
      Validators.required])),
  })
   get f() { return this.FaqData.controls; }
   get sf() { return this.staticData.controls; }

  constructor(private el: ElementRef,public router: Router, public service: GlobalService) { 
      if(this.currentUrl == '/edit-faq'){ 
        this.CurrentDetail= JSON.parse(localStorage.getItem('gra_EditData')||'{}')
        this.LoginCheck =this.CurrentDetail.forLoggedIn;
      }
      if(this.currentUrl == '/edit-faqs'){ 
        this.CurrentDetail= JSON.parse(localStorage.getItem('gra_EditData')||'{}')
        this.imgURL =this.CurrentDetail.thumbnail;
        this.docURL =this.CurrentDetail.content;
      }
  }

  ngOnInit(): void {
  }


  Onsubmit(){
    this.submitted = true;    
      let userdetail:any = this.FaqData;
      var url:any=''; var detail:any={};     
      if(userdetail.valid){
        detail={
          "question": userdetail.value.question,
          "answer": userdetail.value.answer,
          "forLoggedIn":this.LoginCheck
         }  ; 
        if(this.currentUrl == '/edit-faq'){
          url='/faq-update';
          detail.id =this.CurrentDetail._id;
          this.loading=true;
          this.service.updateApi(detail,url).subscribe(((response:any)=>{
            if(response.success ==1){         
              this.FaqData.reset();
              this.submitted = false;  
              this.loading=false;  
              this.service.back();
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
            }
          }), (error:any) => {
            this.loading=false;
          });
        } else {
          url='/faq-create';
          this.loading=true;
          this.service.PostApis(detail,url).subscribe(((response:any)=>{
            if(response.success ==1){         
              this.FaqData.reset();
              this.submitted = false;  
              this.loading=false;  
              this.service.back();
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
            }
          }), (error:any) => {
            this.loading=false;
          });
        }
      
      } else{
        this.loading = false
        userdetail.markAllAsTouched();
        this.scrollToFirstInvalidControl();  
      }
  }

  Onsubmit1(){
    this.submitted = true;    
      let userdetail:any = this.staticData;
      var url:any=''; let formdata:any=new FormData();    
      if(userdetail.valid){
        formdata.append('title',userdetail.value.title);
        formdata.append('description',userdetail.value.description);
        formdata.append('_id',this.CurrentDetail._id);
        formdata.append('status','Active');
        formdata.append('buttonText','Download PDF');
        
        if (this.imgURL == '') {
          this.service.dangerAlert('Upload Image');
          this.loading = false;
          return
        } else {
          if (this.selectedFile != '') {
            formdata.append('thumbnail', this.selectedFile);
          }
        }
        if (this.docURL == '') {
          this.service.dangerAlert('Upload PDF');
          this.loading = false;
          return
        } else {
          if (this.selectedDocFile != '') {
            formdata.append('content', this.selectedDocFile);
          }
        }
          url='/faq-content-update';
          this.loading=true;
          this.service.updateFormData(formdata,url).subscribe(((response:any)=>{
            if(response.success ==1){         
              this.staticData.reset();
              this.submitted = false;  
              this.loading=false;  
              this.service.back();
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
            }
          }), (error:any) => {
            this.loading=false;
          });
      
      } else{
        this.loading = false
        userdetail.markAllAsTouched();
        this.scrollToFirstInvalidControl();  
      }
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }
  
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  getCheckType(event:any){
    this.LoginCheck = event.target.checked;
  }

  getUploadFileDetail(event: any,type:any) {
    if (event.target.files.length > 0) {
      if(type==1){
        this.selectedFile = event.target.files[0];
      } else {
        this.selectedDocFile = event.target.files[0];
      }
      var mimeType = event.target.files[0].type;
      if(type==1){
        if (mimeType.match(/image\/*/) == null) {
          this.service.warningAlert("Only images are supported.");
          return;
        }
      } else {
        if (mimeType.match(/application\/*/) == null) {
          this.service.warningAlert("Only Application are supported.");
          return;
        }
      }
      var reader = new FileReader();
      this.imagePath = event.target.files;
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        if(type==1){
          this.imgURL = reader.result;
        } else {
          this.docURL = reader.result;
        }
      };
    }
  }

  changeImage(id:any) {
    $(id).trigger("click");
  }
}

